import React from 'react';
import {Column, Row, Tooltip} from '@vidazoo/ui-kit';
import {observer} from 'mobx-react';
import dayjs from 'dayjs';
import useChangeLogsModel from '../../common/hooks/useChangeLogsModel';
import useAccountsMetaDataManager from '../../../../common/hooks/useAccountsMetaDataManager';
import theme from './theme.module.scss';

export default observer(function ChangeLogsRow({itemIndex, style}: {itemIndex: number; viewportIndex: number; style: React.CSSProperties}) {
    const model = useChangeLogsModel();
    const metadata = useAccountsMetaDataManager();
    const item = model.maskItems[itemIndex];
    if (!item) return null;
    const background = itemIndex % 2 ? 'var(--change-logs-row-odd-background)' : 'var(--change-logs-row-background)';
    const rowStyle = {...style, '--table-viewport-background-color': background,
        '--table-data-column-background-color': background, '--table-column-sticky-background-color': background} as React.CSSProperties;
    const showAuth = () => model.setSelectedItem({...item.auth, ...(metadata.usersById?.[item.auth?.id] || {})});
    const textCell = (key: string, text: string) => <Column colKey={key}><Tooltip title={text || ''}><span>{text}</span></Tooltip></Column>;
    const name = model.nameByIdAndScope[item.scope + item.model_id]?.name || item.model_id;
    const diff = item.diff ? JSON.stringify(item.diff) : '';
    return <Row style={rowStyle} index={itemIndex} data-change-log-id={item.id}>
        {textCell('scope', item.scope)}
        {textCell('account', item.account)}
        <Column colKey="user" className={theme.user}><Tooltip title={item.auth?.email || ''}>
            <button type="button" className={theme.snapshot} aria-label={`View user for change ${item.id}`} onClick={showAuth}>{item.auth?.email || ''}</button>
        </Tooltip></Column>
        {textCell('action', item.action)}
        {textCell('model_name', item.model_name)}
        <Column colKey="model_id"><Tooltip title={name}>
            <a className={!item.model_link ? theme.unlinked : undefined} href={item.model_link || undefined} target="_blank" rel="noopener noreferrer">{name}</a>
        </Tooltip></Column>
        <Column colKey="date">{dayjs(Number(item.date)).format('MMM DD, YYYY, HH:MM')}</Column>
        <Column colKey="diff"><Tooltip title={diff}>
            <button type="button" className={theme.snapshot} aria-label={`View diff for change ${item.id}`} onClick={() => model.setSelectedItem(item.diff)}>{diff}</button>
        </Tooltip></Column>
    </Row>;
});
